import React, { FC, useMemo } from 'react';
import { ExerciseDto } from '../../../../shared/dtos/exercise.dto';
import { ExerciseTagDto } from '../../../../shared/dtos/exerciseTag.dto';
import i18next from 'i18next';
import { Badge, Button, Stack, Table } from 'react-bootstrap';
import { exerciseTypeLabels } from '../../util/types';
import MediaPlayer from '../MediaPlayer';

type ExerciseTableProps = {
  exercises: ExerciseDto[];
  tags: ExerciseTagDto[];
  onClick?: (exercise: ExerciseDto) => void;
}

const ExerciseTable: FC<ExerciseTableProps> = ({ exercises, tags, onClick }: ExerciseTableProps) => {
  const language: string = i18next.language;

  const tagMap = useMemo(() => {
    const map: Map<string, ExerciseTagDto> = new Map<string, ExerciseTagDto>();
    for (const tag of tags) {
      map.set(tag.id, tag);
    }
    return map;
  }, [tags]);

  const tagById = (id: string): ExerciseTagDto | undefined => tagMap.get(id);

  return (
    <Table striped bordered hover responsive className='h-75 overflow-auto'>
      <thead>
        <tr>
          <th>{ i18next.t('exerciseVideo.media') }</th>
          <th className='centered-td'>{ i18next.t('exerciseVideo.germanTitle') }</th>
          <th className='centered-td'>{ i18next.t('exerciseVideo.englishTitle') }</th>
          <th className='centered-td'>{ i18next.t('exerciseVideo.exerciseType') }</th>
          <th className='centered-td'>{ i18next.t('exerciseVideo.tags') }</th>
          { onClick !== undefined && (<th></th>) }
        </tr>
      </thead>
      <tbody>
        {exercises.map((exercise: ExerciseDto) => (
          <tr key={exercise.id}>
            <td className='centered-td w-25'>
              <div className="p-3">
                <MediaPlayer exercise={exercise}/>
              </div>
            </td>
            <td className='centered-td'>{exercise.deName}</td>
            <td className='centered-td'>{exercise.enName}</td>
            <td className='centered-td'>{i18next.t(exerciseTypeLabels[exercise.exerciseType])}</td>
            <td className='centered-td w-25'>
              <Stack direction="horizontal" gap={2} className="flex-wrap justify-content-start">
                {exercise.tagIds.map((id: string) => {
                  const tag = tagById(id);

                  if (!tag) {
                    return null;
                  }

                  return (
                    <Badge key={id} bg="primary">
                      {language === 'de' ? tag.de : tag.en}
                    </Badge>
                  );
                })}
              </Stack>
            </td>
            {onClick !== undefined && (
              <td className='centered-td'>
                <Button variant='dark' onClick={() => {onClick(exercise);}}>
                  { i18next.t('generic.edit')}
                </Button>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default ExerciseTable;
